const ImprovementIdeasChartsConfigurationPage = () => import('frontend/pages/settings/improvementIdea/ImprovementIdeasChartsConfigurationPage')
const ImprovementIdeasFieldsByRoleConfigurationPage = () => import('frontend/pages/settings/improvementIdea/ImprovementIdeasFieldsByRoleConfigurationPage')
const SettingsImprovementIdeaDetails = () => import('frontend/pages/settings/improvementIdea/idea-details/views/SettingsImprovementIdeaDetails.vue')

import { IMPROVEMENT_IDEA_SOURCE } from 'frontend/constants/improvementIdeas'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

export default [

  {
    path: 'charts-config-improvement-ideas',
    name: 'settings-chartstable-config-improvement-ideas',
    components: {
      default: ImprovementIdeasChartsConfigurationPage,
    },
  },
  {
    path: SETTINGS_CARDS_TOKENS.improvementIdeasFieldsByRoleConfig.name,
    name: SETTINGS_CARDS_TOKENS.improvementIdeasFieldsByRoleConfig.name,
    components: {
      default: ImprovementIdeasFieldsByRoleConfigurationPage,
    },
    props: {
      default: {
        source: IMPROVEMENT_IDEA_SOURCE,
      },
    },
  },
  {
    path: 'improvement-idea-details',
    name: SETTINGS_CARDS_TOKENS.improvementIdeasDetailsConfig.name,
    components: {
      default: SettingsImprovementIdeaDetails,
    },
  },
]
